import { render, staticRenderFns } from "./BillForm.vue?vue&type=template&id=3f0ffd59&scoped=true&"
import script from "./BillForm.vue?vue&type=script&lang=js&"
export * from "./BillForm.vue?vue&type=script&lang=js&"
import style0 from "./BillForm.vue?vue&type=style&index=0&id=3f0ffd59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ffd59",
  null
  
)

export default component.exports